import React from 'react';
import { useField } from 'formik';
import { TextInput, TextInputProps } from '@adc/parallax-component-library';

type Props = {
  name: string;
  label: string;
  disabled?: boolean;
  minLines?: number;
  maxLines?: number;
} & Partial<TextInputProps>;

const TextAreaWithError = ({
  name,
  label,
  disabled = false,
  minLines = 3,
  maxLines = 3,
  ...rest
}: Props) => {
  const [field, meta] = useField(name);

  return (
    <TextInput
      {...(rest as TextInputProps)}
      label={label}
      aria-label={label}
      error={!!(meta.touched && meta.error)}
      supportingText={meta.touched && meta.error && !disabled ? meta.error : ''}
      onChangeText={field.onChange(name)}
      onBlur={field.onBlur(name)}
      value={field.value}
      disabled={disabled}
      maxLines={maxLines}
      minLines={minLines}
      multiline={true}
    />
  );
};

export default TextAreaWithError;
